module.exports = __webpack_public_path__ + "804ee7002c6139ecdbf0dd3f56c57b29.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/tie.png
// module id = 2022
// module chunks = 0